import React from 'react'
import styled from 'styled-components'
import RefreshIcon from '../../../assets/v2/JSX/RefreshIcon'
import Colors from '../../../assets/styles/Colors'
import Responsive from '../../../assets/config/Responsive'
//
//
const StartOver: React.FC<{ onClick: () => void; text?: string; disabled?: boolean; style?: React.CSSProperties }> = ({
  onClick,
  text = 'Start over',
  disabled = false,
  style,
}) => {
  return (
    <Button style={style} $disabled={disabled} onClick={onClick}>
      <RefreshIcon />
      <span>{text}</span>
    </Button>
  )
}
//
const Button = styled.button<{ $disabled: boolean }>`
  /* disabled styles */
  user-select: ${({ $disabled }) => ($disabled === true ? `none` : `unset`)};
  pointer-events: ${({ $disabled }) => ($disabled === true ? `none` : `unset`)};
  opacity: ${({ $disabled }) => ($disabled === true ? `0.8` : `unset`)};
  /* disabled styles */

  padding: 5px;
  border: unset;
  outline: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  color: ${Colors.primaryRed};
  font-size: 18px;

  /* span text */
  span {
    margin-left: 12px;
  }

  /* icon svg */
  svg {
    width: 24px;
    height: 24px;
    color: inherit;
  }

  /* hover */
  &:hover {
    color: ${Colors.hoverRed};
  }

  /* responsive */
  ${Responsive.mobile} {
    font-size: 14px;

    /* svg */
    svg {
      width: 20px;
      height: 20px;
    }

    /*span  */
    span {
      margin-left: 9px;
    }
  }
`
//
export default StartOver
